var map = {
	"./X33-Mall_small.jpg": 920,
	"./all.svg": 921,
	"./apple-watch.png": 922,
	"./b-headphone.png": 923,
	"./coin.svg": 924,
	"./delete-btn.svg": 925,
	"./iphone-pink.png": 926,
	"./love.svg": 927,
	"./mall-banner-cn.jpg": 928,
	"./mall-banner-id.jpg": 929,
	"./mall-banner-ms.jpg": 930,
	"./mall-banner.jpg": 931,
	"./mobile-bg.jpg": 932,
	"./price-high.svg": 933,
	"./price-low.svg": 934,
	"./shopping-cart.svg": 935,
	"./star.svg": 936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;